module.exports = __webpack_public_path__ + "img/IT0000532290190.49372efd.png";